import { Button } from 'primereact/button';
import { Sidebar } from 'primereact/sidebar';
import React, { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import ImageForm from './ImageForm';
import ImageItem from './ImageItem';

function MultipleImagePanel({ images, onValidate, loading, isOpen, onClose }) {
  const [tmpImages, setTmpImages] = useState(images);

  useEffect(() => {
    setTmpImages(images);
  }, [images]);

  const handleAddImage = (image) => {
    setTmpImages((prevImages) => [...prevImages, image]);
  };

  const handleDeleteImage = (image) => {
    setTmpImages((prevImages) => prevImages.filter((img) => img.id !== image.id));
  };

  const customHeader = (
    <React.Fragment>
      <h2 style={{ marginBottom: 0 }} className="text-slate-900 text-2xl font-medium">
        Gérer les images
      </h2>
    </React.Fragment>
  );

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider les modifications`}
        className="w-full"
        onClick={() => onValidate(tmpImages)}
        severity="success"
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 600 }}
      header={customHeader}
      visible={isOpen}
      maskStyle={{ backgroundColor: '#00000080' }}
      onHide={onClose}
      position="right">
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput label={'Images existantes'} className={'flex flex-col gap-y-3'}>
            {tmpImages &&
              tmpImages.map((i) => (
                <ImageItem
                  key={i.id}
                  className="w-full"
                  deleteImage={() => handleDeleteImage(i)}
                  image={i}
                  alt="Prévisualisation de la photo"
                />
              ))}

            {!tmpImages?.length && (
              <span className="italic mt-2 text-slate-400">Aucune image renseignée</span>
            )}
          </FormInput>

          {!loading && (
            <ImageForm
              image={undefined}
              setImage={handleAddImage}
              label="Nouvelle image"
              required={false}
            />
          )}
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default MultipleImagePanel;
